import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { StatusMessage } from "components/StatusMessage";
import { ViewDetails } from "../../../../../components/ViewDetails";

import "./index.css";

interface Props {
  item: IPackage;
}

export function Received({ item }: Props) {
  return (
    <div>
      <StatusMessage
        message="We have received your package"
        actionType="admin"
      />
      <div className="col-12">
        <p>
          We have received your package and will soon start reviewing its
          contents. Some items in the package might be accepted and some might
          be rejected.
        </p>
      </div>
      <hr />
      <ViewDetails item={item} />
    </div>
  );
}
